<div class="modal fade" id="dialogRelatorioAtaPersonalizada" tabindex="-1" role="dialog" 
  aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="bg-primary modal-header text-white">
        Ata de Sessão Pública - {{licitacao.numero | LICITACAO}}
      </div>
      <div class="modal-body pt-0">
        <div class="row">
          <div class="col-12">
            <p-fieldset legend="Opções do Relatório">
              <label for="assinatura">Selecione a assinatura que será usada</label>
              <select [compareWith]="compareFn" id="assinatura" class="form-control" [(ngModel)]="assinatura"
                [ngModelOptions]="{standalone: true}">
                <option *ngFor="let sign of listAssinatura" [ngValue]="sign">{{sign.nome}}</option>
              </select>
              <div class="table-responsive">
                <table class="table table-sm table-eddy">
                  <tbody>
                    <tr *ngFor="let item of assinatura?.pessoas">
                      <td class="text-center">
                        <div class="checkbox checbox-switch switch-success text-right">
                          <label style="margin: 0; text-align: left;">
                            <input type="checkbox" [(ngModel)]="item.selecionado"
                              [ngModelOptions]="{standalone: true}" /><span></span> &nbsp;&nbsp;
                          </label>
                        </div>
                      </td>
                      <td>
                        {{item.pessoa?.nome}}
                      </td>
                      <td>
                        {{item.pessoa?.cpf_cnpj | CPF}}
                      </td>
                      <td>
                        {{item.cargo}}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </p-fieldset>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <p-fieldset legend="Formatos">
              <p-radioButton name="formatoGroup" [value]="format" [label]="format" class="mr-2 mt-2"
                [(ngModel)]="formato" *ngFor="let format of listFormato">
              </p-radioButton>
            </p-fieldset>
          </div>
          <div class="col-6">
            <p-fieldset legend="Orientação">
              <p-radioButton name="formatoGroup" [value]="orient.id" [label]="orient.nome" class="mr-2 mt-2"
                [(ngModel)]="orientacao" *ngFor="let orient of listOrientacao">
              </p-radioButton>
            </p-fieldset>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button (click)="imprimir()" type="button" class="btn btn-primary btn-sm">
          Gerar Relatório
        </button>
        <button type="button" class="btn btn-link btn-sm" data-dismiss="modal">Cancelar</button>
      </div>
    </div>
  </div>
</div>